import axios from 'axios';

const rawAxios = axios.create({
	baseURL: '/api',
	timeout: 100000,
});

export default rawAxios;
